import { defineComponent as _defineComponent } from 'vue'
import { useBasicStore } from '@/stores/basic';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { Message } from 'element-ui';
import { WARNING_MESSAGE, MESSAGE_DURATION } from "@/constants/message";
import { editStatus } from '@/api/vote';

interface Props {
    voteActivity: any,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'publish',
  props: {
    voteActivity: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    voteActivity: any,
}


const basicStore = useBasicStore();
const { userId } = storeToRefs(basicStore);

const disabled=ref(true)

function publishbtn() {
    disabled.value=false
    // let arr = {
    //     userId: userId.value,
    //     status: "publish_ing",
    //     voteId: props.voteActivity.id
    // }
    // console.log("publishbtn ------------------------ 发布")
    // editStatus(arr)
    //     .then(res => {
    //         console.log(res)
    //         if (res.code == "000") {
    //             Message({
    //                 type: 'success',
    //                 message: "发布成功",
    //                 duration: MESSAGE_DURATION.NORMAL,
    //             });
    //         } else {
    //             Message({
    //                 type: 'warning',
    //                 message: res.msg,
    //                 duration: MESSAGE_DURATION.NORMAL,
    //             });
    //         }
    //     }).catch(err => {
    //         console.log(err)
    //     })
}
expose({
    publishbtn
})

return { __sfc: true,basicStore, userId, props, disabled, publishbtn }
}

})